<template>
  <b-modal
    id="edit-ecl-modal"
    title="ECL Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Edit ECL Details</h2>
    </template>
    <validation-observer ref="eclCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            @input="fetchBuildings()"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="building">
          <template #label>
            Building <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Building"
            :options="buildings"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="police_fire_ambulance">
          <template #label>
            Police Fire Ambulance <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="police_fire_ambulance"
            v-model="police_fire_ambulance"
            v-restrict="regex"
            placeholder="Police Fire Ambulance"
            required
            disabled
          />
        </b-form-group>

        <b-form-group label-for="state_emergency_service">
          <template #label>
            State Emergency Service <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="state_emergency_service"
            v-model="state_emergency_service"
            placeholder="State Emergency Service"
            required
            disabled
          />
        </b-form-group>

         <b-form-group label-for="poisons_information_center">
          <template #label>
            Poisons Information Centre <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="poisons_information_center"
            v-model="poisons_information_center"
            placeholder="Poisons Information Centre"
            required
            disabled
          />
        </b-form-group>

        <b-form-group label-for="crisis_support">
          <template #label>
            Crisis Support
          </template>
          <b-form-input
            id="crisis_support"
            v-model="crisis_support"
            placeholder="Crisis Support"
            disabled
          />
        </b-form-group>


        <b-form-group label-for="nearest_medical_center">
          <template #label>
            Medical Centre
          </template>
          <b-form-input
            id="nearest_medical_center"
            v-model="nearest_medical_center"
            placeholder="Medical Centre"
          />
        </b-form-group>


        <b-form-group label-for="nearest_medical_center_contact">
          <template #label>
            Medical Centre Contact
          </template>
          <b-form-input
            id="nearest_medical_center_contact"
            v-model="nearest_medical_center_contact"
            placeholder="Medical Centre Contact"
          />
        </b-form-group>


        <b-form-group label-for="nearest_medical_hospital">
          <template #label>
            Medical Hospital
          </template>
          <b-form-input
            id="nearest_medical_hospital"
            v-model="nearest_medical_hospital"
            placeholder="Medical Hospital"
          />
        </b-form-group>

        <b-form-group label-for="nearest_medical_hospital_contact">
          <template #label>
            Medical Hospital Contact
          </template>
          <b-form-input
            id="nearest_medical_hospital_contact"
            v-model="nearest_medical_hospital_contact"
            placeholder="Medical Hospital Contact"
          />
        </b-form-group>

        <b-form-group label-for="flood_emergency_contractor_contact">
          <template #label>
            Flood Emergency Contractor Contact
          </template>
          <b-form-input
            id="flood_emergency_contractor_contact"
            v-model="flood_emergency_contractor_contact"
            placeholder="Flood Emergency Contractor Contact"
          />
        </b-form-group>

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Update
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: {ecl:Object},
  mixins: [util],
  data() {
    return {
      required,      
      regex: /^[a-zA-Z ]*$/,
      sites: [],
      site: "",
      buildings: [],
      building: "",
      police_fire_ambulance: '000',
      state_emergency_service: '132500',
      poisons_information_center: '131126',
      crisis_support: '131114',
      nearest_medical_center: "",
      nearest_medical_center_contact: "",
      nearest_medical_hospital: "",
      nearest_medical_hospital_contact: "",      
    };
  },
  methods: {
    ...mapActions({
      updateEcl: "appData/updateEcl",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),

    async submit() {
      try {
        const formData = new FormData();        
        formData.append("site", this.site.id);
        formData.append("building", this.building.id);
        formData.append("police_fire_ambulance", this.police_fire_ambulance);
        formData.append("state_emergency_service", this.state_emergency_service);
        formData.append("poisons_information_center", this.poisons_information_center);
        formData.append("crisis_support", this.crisis_support);
        formData.append("nearest_medical_center", this.nearest_medical_center);
        formData.append("nearest_medical_center_contact", this.nearest_medical_center_contact);
        formData.append("nearest_medical_hospital", this.nearest_medical_hospital);
        formData.append("nearest_medical_hospital_contact", this.nearest_medical_hospital_contact);
        formData.append("flood_emergency_contractor_contact", this.flood_emergency_contractor_contact);
        formData.append("updated_by", this.getLoggedInUser.id);

        const res = await this.updateEcl({
          payload: formData,
          pk: this.ecl.id
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Ecl Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-ecl-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },


    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      this.building = "";
       if (!this.site) {
        this.buildings = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },

    reset() {
      this.site = "";
      this.building = "";
      this.nearest_medical_center = "";
      this.nearest_medical_center_contact = "";
      this.nearest_medical_hospital = "";
      this.nearest_medical_hospital_contact = "";
      this.flood_emergency_contractor_contact = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;

    const buildings =  await this.getBuildingsDDL();
    this.buildings = buildings.data;

    if(this.ecl)
    {
      this.site = this.sites.find(s => s.id === this.ecl.site);
      this.building = this.buildings.find(b => b.id === this.ecl.building);
      this.nearest_medical_center = this.ecl.nearest_medical_center;
      this.nearest_medical_center_contact = this.ecl.nearest_medical_center_contact;
      this.nearest_medical_hospital = this.ecl.nearest_medical_hospital;
      this.nearest_medical_hospital_contact = this.ecl.nearest_medical_hospital_contact;
      this.flood_emergency_contractor_contact = this.ecl.flood_emergency_contractor_contact;
    }

  },
};
</script>

<style></style>
